/** @file Applies one confirmed commit to the stores: own-batch match, patches, the feed, the hash cadence. */
import type { Patch } from 'immer';
import type { CommitSummary } from '@pose2d/api/types';
import { docStore } from '../../stores/docStore';
import { liveStore } from '../../stores/liveStore';
import { applyConfirmed } from './applyConfirmed';
import { hashCheck } from './hashCheck';
import type { SyncSession } from './liveSession';
import { markOwnCommit } from './markOwnCommit';
import { mergeByKey } from './mergeByKey';

/** Most commit summaries the feed keeps. */
const MAX_FEED = 5000;

/** Advances the confirmed doc by one commit; callers guarantee `summary.rev === slice.rev + 1`. */
export function applyCommit(session: SyncSession, summary: CommitSummary, patches: readonly Patch[]): void {
  const { slice } = docStore.getState();
  if (slice === null) return;
  const live = liveStore.getState();
  const batches = summary.actor === session.actor ? markOwnCommit(live.batches, summary) : live.batches;
  const next = applyConfirmed(slice, batches, summary.rev, patches);
  liveStore.setState({ batches: next.batches, commits: mergeByKey(live.commits, [summary], (c) => c.rev, MAX_FEED) });
  docStore.setState({ slice: next.slice });
  if (hashCheck.crosses(slice.rev, summary.rev)) session.hashDue = true;
}
